import { render, staticRenderFns } from "./CommunityEdit.vue?vue&type=template&id=3a4f5aef&"
import script from "./CommunityEdit.vue?vue&type=script&lang=js&"
export * from "./CommunityEdit.vue?vue&type=script&lang=js&"
import style0 from "./CommunityEdit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports